/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/subscriptions'

const SubscriptionEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchSubscriptionPackages: builder.query<any, void>({
      query: () => `${basePath}/packages`,
    }),

    fetchSubscriptions: builder.query<any, any>({
      query: (params) => ({
        url: `${basePath}`,
        params,
      }),
      providesTags: ['subscriptions']
    }),

    fetchSubscriptionById: builder.query<any, number | string>({
      query: (id) => `${basePath}/${id}`,
      providesTags: ['subscriptions']
    }),

    createSubscription: builder.mutation<any, any>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['subscriptions']
    }),

    updateSubscription: builder.mutation<any, { id: number | string; body: any }>({
      query: ({ id, body }) => ({
        url: `${basePath}/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['subscriptions']
    }),

    cancelSubscription: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/cancel`,
        method: 'POST',
      }),
      invalidatesTags: ['subscriptions']
    }),

    reactivateSubscription: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/reactivate`,
        method: 'POST',
      }),
      invalidatesTags: ['subscriptions']
    }),

    deleteSubscription: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['subscriptions']
    }),

    // puts a deleted subscription back (admins only)
    restoreSubscription: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/restore`,
        method: 'POST',
      }),
      invalidatesTags: ['subscriptions']
    }),

    recordSubscriptionPayment: builder.mutation<any, { id: number | string; body: any }>({
      query: ({ id, body }) => ({
        url: `${basePath}/${id}/payments`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['subscriptions']
    }),

    fetchSubscriptionPayments: builder.query<any, { id: number | string; pageNumber?: number; pageSize?: number }>({
      query: ({ id, pageNumber = 0, pageSize = 20 }) => ({
        url: `${basePath}/${id}/payments`,
        params: { pageNumber, pageSize },
      }),
      providesTags: ['subscriptions']
    }),

    fetchSubscriptionReport: builder.query<any, { startDate: string; endDate: string }>({
      query: (params) => ({
        url: `${basePath}/report`,
        params,
      }),
    }),

    fetchSubscriptionOrders: builder.query<any, any>({
      query: (params) => ({
        url: `/orders/subscription`,
        params,
      }),
      providesTags: ['orders']
    }),
  })

export default SubscriptionEndpoints
